import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4ce1ec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calculator" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dollar-sign" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "PaginationHolderTop" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tenge" }, null, -1))
const _hoisted_15 = { class: "PaginationHolderDown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_invoices_history_filters = _resolveComponent("invoices-history-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_on_handle_billing)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large SubmitOrder",
          title: "Прокинуть в биллинг",
          loading: _ctx.state.is_loading,
          onCancel: _ctx.toggleBilling,
          onConfirm: _ctx.handleBilling
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_select, {
              value: _ctx.state.company_id,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.company_id) = $event)),
              placeholder: "Выберите компанию",
              label: "name",
              "search-by": "name",
              options: _ctx.data_state.companies.list,
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка городов произошла ошибка",
              "infinite-scroll": "",
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
              onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
              onSearch: _ctx.searchCompanies,
              onOptionBySearch: _ctx.unshiftFoundCompany
            }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "История накладных" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_button_dropdown, {
          icon: "fas fa-download",
          class: "mr-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "small primary text",
              loading: _ctx.state.invoices.is_loading,
              disabled: _ctx.state.invoices.is_loading,
              onClick: _ctx.exportExcel
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Накладные на сегодня ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]),
            _createVNode(_component_the_button, {
              class: "small primary text",
              loading: _ctx.state.is_kaspi_report_loading,
              disabled: _ctx.state.is_kaspi_report_loading,
              onClick: _ctx.downloadKaspiReport
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отчет каспи ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ]),
          _: 1
        }),
        (
                        _ctx.havePermissions([
                            'order-logistics-info-import-declared-price',
                            'all-root-permission',
                        ])
                    )
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "mr-3",
              to: "/invoices/price-import"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, {
                  class: "primary small",
                  hint: "Импортировать объявленную стоимость"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.havePermissions(['sdt-order.sync-statuses', 'all-root-permission']))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "mr-3",
              to: "/invoices/sync"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, {
                  class: "primary small",
                  hint: "Отправка статусов в СДТ"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: "/calculator",
          class: "mr-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "primary small",
              hint: "Калькулятор"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (
                        _ctx.havePermissions([
                            'order-logistics-info-import-cash-sum',
                            'all-root-permission',
                        ])
                    )
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: "/invoices/import"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, {
                  class: "primary small",
                  hint: "Импортировать сумму налички"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: "/invoices/cancel",
          class: "ml-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "small red",
              hint: "Отмена накладных импорта"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_invoices_history_filters, {
      class: "mt-6",
      loading: _ctx.state.invoices.is_loading,
      onSearch: _ctx.applyFilters,
      onResetted: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onResetted"]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.state.invoices.is_failed && !_ctx.state.invoices.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.invoices.is_loading,
            text: "При получении истории накладных произошла ошибка",
            "error-message": _ctx.state.invoices.failure.error_state.message,
            "error-url": _ctx.state.invoices.failure.error_state.url,
            "error-status": _ctx.state.invoices.failure.error_state.status,
            onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadInvoices(_ctx.state.invoices.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_the_button, {
                class: "primary small mr-2",
                loading: _ctx.state.invoices.is_loading,
                onClick: _ctx.tablesStore.toggleModal
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_new_limit, {
                  disabled: _ctx.state.invoices.is_loading,
                  value: _ctx.state.limit,
                  "total-items": _ctx.state.invoices.pagination.total_items,
                  loading: _ctx.state.is_quantity_loading,
                  onChange: _ctx.onLimitChange
                }, null, 8, ["disabled", "value", "total-items", "loading", "onChange"]),
                _createVNode(_component_new_pagination, {
                  class: "ml-6",
                  disabled: _ctx.state.invoices.is_loading,
                  "current-page": _ctx.state.invoices.pagination.current_page,
                  "total-pages": _ctx.state.invoices.pagination.total_pages,
                  onChangePage: _ctx.loadInvoices
                }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
              ])
            ]),
            _createVNode(_component_table_scroll_wrapper, {
              loading: _ctx.state.invoices.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.invoices.is_loading,
                  columns: _ctx.LTLInvoicesColumns,
                  rows: _ctx.state.invoices.list
                }, {
                  td: _withCtx(({ row, column }) => [
                    (
                                    row[column.key] && column.key === 'additional_services_values'
                                )
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(_ctx.getCheckOrTimesIcon(row[column.key].length))
                        }, null, 2))
                      : (column.key === 'billing_enabled')
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: _normalizeClass(_ctx.getCheckOrTimesIcon(row[column.key]))
                          }, null, 2))
                        : (column.key === 'pv')
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 2,
                              class: _normalizeClass(
                                        _ctx.getCheckOrTimesIcon(
                                            [20, 21].includes(row.calculation_status)
                                        )
                                    )
                            }, null, 2))
                          : (column.key === 'bl')
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 3,
                                class: _normalizeClass(_ctx.getCheckOrTimesIcon(row.calculation_status === 21))
                              }, null, 2))
                            : (column.key === 'is_pickup')
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 4,
                                  class: _normalizeClass(_ctx.getCheckOrTimesIcon(row.is_pickup))
                                }, null, 2))
                              : (column.key === 'is_self_delivery')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 5,
                                    class: _normalizeClass(_ctx.getCheckOrTimesIcon(row.is_self_delivery))
                                  }, null, 2))
                                : (column.key === 'cost_prediction')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _createTextVNode(_toDisplayString(_ctx.getCostPrediction(row)), 1)
                                    ], 64))
                                  : (row[column.key] && column.key === 'shipment_type')
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 7,
                                        class: _normalizeClass(_ctx.getShipmentIconClass(row[column.key]))
                                      }, null, 2))
                                    : (
                                    column.key === 'order_number' &&
                                    row.order_id &&
                                    row.order_number
                                )
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 8,
                                          class: "text-blue-500",
                                          to: `/order/${row.order_id}`
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(row.order_number), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (
                                    column.key === 'invoice_number' && row.invoice_number && row.id
                                )
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 9,
                                            class: "text-blue-500",
                                            to: `/invoice/${row.id}`
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(row.invoice_number), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                        : (row.receiver && column.key === 'receiver')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                              (column.customHint === 'full_address')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString(_ctx.cutName(row.receiver.full_address, 25)), 1)
                                                  ], 64))
                                                : (column.customHint === 'comment')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(_toDisplayString(_ctx.cutName(row.receiver.comment, 25)), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                            ], 64))
                                          : (row.sender && column.key === 'sender')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                                _createTextVNode(_toDisplayString(_ctx.cutName(row.sender.full_address, 25)), 1)
                                              ], 64))
                                            : (row.status_name && column.key === 'status_name')
                                              ? (_openBlock(), _createBlock(_component_cheap, {
                                                  key: 12,
                                                  class: _normalizeClass(["small font-bold", _ctx.getCheapClass(row.status_id)])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.cutName(row.status_name, 12)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]))
                                              : (row.sender && column.key === 'direction')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                                    _createTextVNode(_toDisplayString(row.direction), 1)
                                                  ], 64))
                                                : (row.sender && column.key === 'created_at')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                                                      _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.created_at)), 1)
                                                    ], 64))
                                                  : (column.key === 'delivery_date')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
                                                        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.delivery_date)), 1)
                                                      ], 64))
                                                    : (column.key === 'date_arrival_receiver_city')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                                                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.date_arrival_receiver_city)), 1)
                                                        ], 64))
                                                      : (column.key === 'take_date')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 17 }, [
                                                            _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.take_date)), 1)
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 18 }, [
                                                            _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 12)), 1)
                                                          ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_the_button, {
                      class: "small primary",
                      hint: "Прокинуть в биллинг",
                      onClick: ($event: any) => (_ctx.toggleBilling(row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows"])
              ]),
              _: 1
            }, 8, ["loading"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_new_limit, {
                disabled: _ctx.state.invoices.is_loading,
                value: _ctx.state.limit,
                "total-items": _ctx.state.invoices.pagination.total_items,
                loading: _ctx.state.is_quantity_loading,
                onChange: _ctx.onLimitChange
              }, null, 8, ["disabled", "value", "total-items", "loading", "onChange"]),
              _createVNode(_component_new_pagination, {
                class: "ml-6",
                disabled: _ctx.state.invoices.is_loading,
                "current-page": _ctx.state.invoices.pagination.current_page,
                "total-pages": _ctx.state.invoices.pagination.total_pages,
                onChangePage: _ctx.loadInvoices
              }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
            ])
          ]))
    ])
  ]))
}